export function sqlDateToUSDate(sqlDate, defaultIfEmpty = '') {
  if (!sqlDate) return defaultIfEmpty;

  // format the date string
  let date = sqlDate.replace(/[-]/g, '/').split(' ')[0];
  // parse the proper date string from the formatted string.
  date = Date.parse(date);
  // create new date
  return new Date(date).toLocaleDateString('en-US', {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}

/**
* Returns the date string in YYYY-MM-DD format.
* @param {Date} date - The date to convert to YYYY-MM-DD format.
* @returns {string} - The date string in YYYY-MM-DD format.
*/
export function getDateYYYYMMDD(date) {
  // Extract the year, month, and day from the date
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');

  // Construct the date string in YYYY-MM-DD format
  const dateStr = `${year}-${month}-${day}`;

  // Return the date string
  return dateStr;
}


/**
* Returns the date that is `days` days after today's date.
* @param {number} days - The number of days to add to today's date.
* @returns {Date} - The date that is `days` days after today's date.
*/
export function getDateAfterDays(days = 0) {
  // Get the current date
  const currentDate = new Date();

  // Calculate the date that is `days` days after today's date
  const futureDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + days);

  // Return the date that is `days` days after today's date
  return futureDate;
}

/**
* Returns the date that is `years` years ago from today's date.
* @param {number} years - The number of years to go back in time.
* @returns {Date} - The date that is `years` years ago from today's date.
*/
export function getDateYearsAgo(years = 0) {
  // Get the current date
  const today = new Date();

  // Calculate the date that is `years` years ago by subtracting `years` from the current year
  const yearsAgoDate = new Date(today.getFullYear() - years, today.getMonth(), today.getDate());

  // Return the date that is `years` years ago
  return yearsAgoDate;
}


/**
 * 
 * IMPORTANT! I am removing the time zone from the calculation
 *            Due to buggy piece. dDate returns current date, not UTC date
 * 
 * Formats a date to display it in a human-readable format
 * @param {string} date - A string representing a date in ISO format with removal of the "T" and "Z" characters (e.g. "2022-01-01 00:00:00.000")
 * @returns {string} - The formatted date as a string
 */
export function getTimestamp(date) {
  //convert date string to ISO format '2015-02-10T10:12:50.5000z'
  date = date.substring(0,19).replace(' ','T') + '.000Z';
  let message = '';

  // Get the timezone offset in minutes.
  //SEE COMMENT const timeZoneOffsetInMinutes = new Date().getTimezoneOffset();

  // Convert minutes to milliseconds.
  //SEE COMMENT const timeZoneOffsetInMS = timeZoneOffsetInMinutes * 60 * 1000;

  // Get the current time in the local timezone.
  const currentTime = new Date();

  // Get the date to check.
  const dateToCheck = new Date(date);

  // Calculate the difference in milliseconds between the current date and the date to check, adjusted for the timezone offset.
  const timeDifferenceInMS = currentTime.getTime() - dateToCheck.getTime(); //SEE COMMENT  - timeZoneOffsetInMS;

  // Convert the difference to minutes.
  const timeDifferenceInMinutes = Math.floor(timeDifferenceInMS / 1000 / 60);

  // Determine the appropriate message based on the number of minutes elapsed.
  if (timeDifferenceInMinutes <= 5) { // less than 5 mins
    message = 'just now';
  } else if (timeDifferenceInMinutes < 60) { // less than an hour ago
    message = `${timeDifferenceInMinutes} minutes ago`;
  } else if (timeDifferenceInMinutes < 720) { // 12 hours in mins
    message = `approx. ${Math.round(timeDifferenceInMinutes / 60)} hours ago`;
  } else { // Over 12 hours ago

    // Get the UTC time by subtracting the timezone offset.
//SEE COMMENT     const utcTime = new Date(dateToCheck.getTime() - timeZoneOffsetInMS);

    // Subtract timezone difference from the UTC time.
//SEE COMMENT const localTimeUtc = new Date(utcTime.getTime() - timeZoneOffsetInMS);

    // Get the time string in hh:mm:ss format from localTimeUtc.
//SEE COMMENT const time = localTimeUtc.toISOString().replace(/T|Z/g, ' ').substring(11, 19);
    const time = dateToCheck.toISOString().replace(/T|Z/g, ' ').substring(11, 19);

    // Format the timestamp message as a string with date and time.
//SEE COMMENT message = `${(localTimeUtc.getMonth() + 1).toString().padStart(2, '0')}/${localTimeUtc.getDate().toString().padStart(2, '0')}/${localTimeUtc.getFullYear()} @ ${time}`;
    message = `${(dateToCheck.getMonth() + 1).toString().padStart(2, '0')}/${dateToCheck.getDate().toString().padStart(2, '0')}/${dateToCheck.getFullYear()} @ ${time}`;
  }

  return message;
};

const dateUtils = {
   sqlDateToUSDate,
   getDateAfterDays,
   getDateYearsAgo,
   getDateYYYYMMDD,
   getTimestamp,
};

export default dateUtils;

